import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';

import { Auth0AppStateProvider } from 'contexts/Auth0AppStateContext';
import { AnalyticsContextProvider } from 'lane-shared/contexts/AnalyticsContext';
import { InviteContextProvider } from 'lane-shared/contexts/InviteContext';
import { RootLevelFlagsProvider } from 'lane-shared/contexts/RootLevelFlagContext/RootLevelFlagsContextProvider';
import { ApolloWrapper } from './ApolloWrapper';
import { Auth0Wrapper } from './Auth0Wrapper';
import { analyticsHelper } from './helpers/analytics';
import { SyncAuth0AppState } from './SyncAuth0AppState';

// Polyfill for ReactDOM.findDOMNode which was removed in React 19
// Some third-party libraries still use react-transition-group without nodeRef
// This prevents crashes - transitions will be instant but won't break the app
if (!('findDOMNode' in ReactDOM)) {
  (ReactDOM as any).findDOMNode = () => null;
}

export default function render(Component: any, containerId = 'root') {
  const container = document.getElementById(containerId);
  const root = createRoot(container!);

  root.render(
    <RootLevelFlagsProvider>
      <Auth0AppStateProvider>
        <Auth0Wrapper>
          <ApolloWrapper>
            <InviteContextProvider>
              <SyncAuth0AppState />
              <AnalyticsContextProvider analyticsGenerator={analyticsHelper}>
                <Component />
              </AnalyticsContextProvider>
            </InviteContextProvider>
          </ApolloWrapper>
        </Auth0Wrapper>
      </Auth0AppStateProvider>
    </RootLevelFlagsProvider>
  );
}
